import React from 'react';
import { useTranslation } from 'react-i18next';

import PageLayout from './PageLayout';
import SideMenu from './SideMenu';
import ArticlesPagination from './ArticlesPagination';

interface ProjectsAndIncentivesPageLayoutProps {
  currentSlug: string;
  children: React.ReactNode;
}

const ProjectsAndIncentivesPageLayout = ({
  currentSlug,
  children,
}: ProjectsAndIncentivesPageLayoutProps): React.ReactElement => {
  const { t } = useTranslation();
  const entries = [
    {
      title: t('projects_and_incentives.projects_page.title', 'Projects'),
      url: '/projects-and-incentives/projects',
      isActive: currentSlug === 'projects',
    },
    {
      title: t('projects_and_incentives.incentives_page.title', 'Incentives'),
      url: '/projects-and-incentives/incentives',
      isActive: currentSlug === 'incentives',
    },
  ];

  return (
    <PageLayout
      title={t('projects_and_incentives.page_title', 'Projects and Incentives')}
      sideBarChildren={<SideMenu entries={entries}></SideMenu>}
      withPageContentBox
    >
      {children}
      <ArticlesPagination entries={entries}></ArticlesPagination>
    </PageLayout>
  );
};

export default ProjectsAndIncentivesPageLayout;
